import script from "./QuizHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuizHeader.vue?vue&type=script&setup=true&lang=ts"

import "./QuizHeader.vue?vue&type=style&index=0&id=1c8e4c3d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c8e4c3d"]])

export default __exports__